import styled from '@emotion/styled';
import { NextPage } from 'next';
import { FaFacebookF, FaLine, FaTiktok, FaYoutube } from 'react-icons/fa';
import { IDataLayerGlobal } from 'src/interface/data-layer';
import { ISocialList } from 'src/interface/widgets';
import { controller } from 'src/switch-themes';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';

const { socials } = controller;

const SOCIAL_LIST: ISocialList[] = [
  {
    id: 1,
    icon: <FaFacebookF id='facebook' size={20} />,
    link: socials?.facebook,
    name: 'facebook',
    className: 'icon-facebook'
  },
  // {
  //   id: 2,
  //   icon: <FaTwitter id='twitter' size={20} />,
  //   link: socials?.twitter,
  //   name: 'twitter',
  //   className: 'icon-twitter'
  // },
  {
    id: 3,
    icon: <FaTiktok id='tiktok' size={20} />,
    link: socials?.tiktok,
    name: 'tiktok',
    className: 'icon-tiktok'
  },
  {
    id: 4,
    icon: <FaYoutube id='youtube' size={20} />,
    link: socials?.youtube,
    name: 'youtube',
    className: 'icon-youtube'
  },
  {
    id: 5,
    icon: <FaLine id='line' size={20} />,
    link: socials?.line,
    name: 'line',
    className: 'icon-line'
  }
];

type Props = {
  showTitle?: boolean;
  title?: string;
  eventDataLayer?: IDataLayerGlobal;
  right?: boolean;
};
const WidgetFollow: NextPage<Props> = ({ showTitle = true, right = false, title, eventDataLayer }) => {
  return (
    <>
      <WidgetWrapper className='widget-follow' >
        {showTitle && (
          <div className='tags-title'>
            <p>{title}</p>
          </div>
        )}
        <div className={`tags-items ${right && '--right'}`}>
          {SOCIAL_LIST.map(
            (item: ISocialList, index: number) =>
              item?.link && (
                <a
                  tabIndex={-1}
                  target='_blank'
                  key={index}
                  href={item?.link}
                  rel='noopener nopopopener nofollow'
                  aria-label='social-share'
                  title='social-share'
                  // ! DATALAYER
                  onClick={() =>
                    sendDataLayerGlobal({
                      ...eventDataLayer,
                      data: {
                        title: item?.name,
                        heading: title,
                        index: index + 1,
                        ...eventDataLayer?.data
                      }
                    })
                  }
                >
                  {item?.icon}
                </a>
              )
          )}
        </div>
      </WidgetWrapper>
    </>
  );
};

const WidgetWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  .tags-title {
    margin-top: 30px;
    width: 100%;
    position: relative;
    font-size: 20px;
    font-weight: 700;
    color: ${props => props.color};
    border-bottom: 2px solid #888888;
    margin-bottom: 20px;
    &::before {
      content: '';
      position: absolute;
      bottom: -2px;
      width: 150px;
      max-width: 100%;
      height: 2px;
      background-color: var(--secondary-color);
    }
  }
  .tags-items {
    display: flex;
    align-items: flex-start;
    width: 100%;
    gap: 10px;
    &.--right {
      justify-content: flex-end;
    }
    a {
      svg {
        vertical-align: middle;
        height: 36px;
        width: 36px;
        padding: 7px;
        border-radius: 100%;
        background: #fff;
        background-blend-mode: overlay, normal;
        color: var(--primary-color-new);
        transition: 0.1ms all ease-in-out;
        box-shadow: 3px 5px 6px 2px #00000036;
        @media (max-width: 475px) {
          height: 30px;
          width: 30px;
          padding: 6px;
        }
        &:hover {
          color: #fff;
          background: transparent;
          border: 1px solid #fff;
        }
      }
    }
    @media (max-width: 767px) {
      gap: 5px;
    }
  }
`;
export default WidgetFollow;
